import {combineReducers} from 'redux';

import keywordsListReducer from './data/keywordsListReducer';
import documentsListReducer from './data/documentsListReducer';
import databaseSelectorReducer from './data/databaseSelectorReducer';
import searchResultsReducer from './data/searchResultsReducer';
import databaseAccordReducer from './data/databaseAccordReducer';
import keywordAccordReducer from './data/keywordAccordReducer';
import docAccordReducer from './data/docAccordReducer';
import detailAccordReducer from './data/detailAccordReducer';
import plotlyClickReducer from './data/plotlyClickReducer';
import navBarReducer from './data/navBarReducer';
import spinnerReducer from './data/spinnerReducer';
import searchButtonReducer from './data/searchButtonReducer';
import savedArticleReducer from './data/savedArticleReducer';
import taskIdReducer from './data/taskIdReducers';
import rankedArticleReducer from './data/rankedArticleReducer';
import historyListReducer from './data/historyListReducer';
import searchSpaceReducer from './data/searchSpaceReducer';
import nameSearchReducer from './data/nameSearchReducer';
import alertsReducer from './data/alertsReducer';
import searchTimeReducer from "./data/searchTimeReducer";
import referencesReducer from './data/referencesReducer';

const reducers = combineReducers({
    keywords: keywordsListReducer,
    documents: documentsListReducer,
    database: databaseSelectorReducer,
    searchResults: searchResultsReducer,
    dbAccord: databaseAccordReducer,
    keywordAccord: keywordAccordReducer,
    docAccord: docAccordReducer,
    detailAccord: detailAccordReducer,
    plotlyClickVar: plotlyClickReducer,
    navBar: navBarReducer,
    spinner: spinnerReducer,
    searchButton: searchButtonReducer,
    savedArticle: savedArticleReducer,
    taskId : taskIdReducer,
    rankedArticle : rankedArticleReducer,
    historyList : historyListReducer,
    searchSpace : searchSpaceReducer,
    nameSearch : nameSearchReducer,
    references : referencesReducer,
    alerts: alertsReducer,
    searchTime : searchTimeReducer
});

export default reducers;
